// app/javascript/modules/theme.js

function initThemeToggle() {
  var themeToggle = document.getElementById('theme-toggle');
  if (!themeToggle) return;

  var sunIcon = themeToggle.querySelector('.icon-sun');
  var moonIcon = themeToggle.querySelector('.icon-moon');
  var isDark = document.documentElement.classList.contains('dark');

  // Sync icon display with current theme
  if (isDark) {
    if (sunIcon) sunIcon.classList.remove('hidden');
    if (moonIcon) moonIcon.classList.add('hidden');
  } else {
    if (sunIcon) sunIcon.classList.add('hidden');
    if (moonIcon) moonIcon.classList.remove('hidden');
  }

  // Avoid duplicate binding
  if (themeToggle.dataset.bound === 'true') return;
  themeToggle.dataset.bound = 'true';

  themeToggle.addEventListener('click', function() {
    var nowDark = document.documentElement.classList.toggle('dark');
    localStorage.setItem('theme', nowDark ? 'dark' : 'light');

    if (sunIcon) sunIcon.classList.toggle('hidden', !nowDark);
    if (moonIcon) moonIcon.classList.toggle('hidden', nowDark);
  });
}

document.addEventListener('turbolinks:load', initThemeToggle);
